import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {getUserList} from "@/types/Order";
import {onMounted, ref} from "vue";
import {useGlobalSetting} from "@/lib/utils";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserSelect',
  props: /*@__PURE__*/_mergeModels({
  variant: {
    type: String,
    default: "outlined"
  },
  required: {
    type: Boolean,
    default: false
  },
  itemTitle: {
    type: String,
    default: "full_name",
  },
  itemValue: {
    type: String,
    default: "id",
  },
  label: {
    type: String,
    default: "Benutzer wählen",
  },
  multiple: {
    type: Boolean,
    default: false,
  }
}, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {

const selected = _useModel<any | any[]>(__props, "modelValue")



const items = ref<any[]>([]);

onMounted(async () => {
  items.value = await getUserList()
});

return (_ctx: any,_cache: any) => {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createBlock(_component_v_select, {
    modelValue: selected.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selected).value = $event)),
    items: items.value,
    "item-title": __props.itemTitle,
    "item-value": __props.itemValue,
    label: __props.label,
    variant: _unref(useGlobalSetting)().globalTextVariant,
    multiple: __props.multiple,
    chips: __props.multiple,
    "closable-chips": __props.multiple,
    rules: __props.multiple ? [v => v.length > 0 || 'Mindestens ein Mitarbeiter erforderlich'] : [],
    class: "mb-3"
  }, {
    "prepend-item": _withCtx(() => [
      _createVNode(_component_v_list_item_title, { class: "text-center font-weight-bold px-4 py-2" }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode(" Mitarbeiter auswählen ")
        ])),
        _: 1,
        __: [1]
      }),
      _createVNode(_component_v_divider)
    ]),
    item: _withCtx(({ props: itemProps, item }) => [
      _createVNode(_component_v_list_item, _mergeProps(itemProps, {
        title: item.raw[__props.itemTitle],
        subtitle: item.raw.id
      }), {
        prepend: _withCtx(() => [
          _createVNode(_component_v_avatar, {
            size: "32",
            color: "grey-lighten-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                icon: "mdi-account",
                size: "18"
              })
            ]),
            _: 1
          })
        ]),
        _: 2
      }, 1040, ["title", "subtitle"])
    ]),
    selection: _withCtx(({ item }) => [
      _createVNode(_component_v_avatar, {
        size: "32",
        color: "grey-lighten-3"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, {
            icon: "mdi-account",
            size: "18"
          })
        ]),
        _: 1
      }),
      _createElementVNode("span", null, _toDisplayString(item.raw[__props.itemTitle]), 1)
    ]),
    _: 1
  }, 8, ["modelValue", "items", "item-title", "item-value", "label", "variant", "multiple", "chips", "closable-chips", "rules"]))
}
}

})